import React from 'react';
import classnames from 'classnames';
import DeviationFlags from '../../ActionBar/buttons/DeviationFlags';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import PremiumFolderDisc from '@wix/da-ds/pkg/Icons/PremiumFolderDisc';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { getDeviationTitle, getDeviationType, } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import Title from '../_partials/Title';
import s from './MobileSubmissionDetails.scss';
var MobileSubmissionDetails = function (_a) {
    var className = _a.className, deviation = _a.deviation, _b = _a.deviation, dailyDeviation = _b.dailyDeviation, premiumFolderData = _b.premiumFolderData, showTitle = _a.showTitle;
    var deviationTitle = getDeviationTitle(deviation);
    var isTextual = [DeviationTypes.LITERATURE].includes(getDeviationType(deviation));
    var _c = normalizePremiumFolderData(premiumFolderData), isPremium = _c.isPremium, isPaidFolder = _c.isPaidFolder;
    var isPremiumNonLit = isPremium && !isTextual;
    return (React.createElement("div", { className: classnames(s['root'], className, dailyDeviation && s['with-flag']) },
        dailyDeviation && showTitle && (React.createElement("div", { className: s['flag'] },
            React.createElement(DeviationFlags, { deviation: deviation }))),
        isPremiumNonLit && (React.createElement(React.Fragment, null, isPaidFolder ? (React.createElement(PremiumFolderDisc, { className: s['folder-icon'], size: IconSize.SMALL })) : (React.createElement(EyeDisc2, { className: s['folder-icon'], size: IconSize.SMALL })))),
        React.createElement(Title, { title: deviationTitle, showTitle: showTitle, className: classnames(s['title'], isPremiumNonLit && s['title-with-folder-icon']) })));
};
MobileSubmissionDetails.displayName = 'MobileSubmissionDetails';
export default MobileSubmissionDetails;
//# sourceMappingURL=MobileSubmissionDetails.js.map